export default __webpack_public_path__ + "static/media/question_modify.cba5275d.svg";